import { CatalogImage } from "./CatalogImage";
import { formatFitmentLabel } from "../lib/catalog";
import { moneyFormatter } from "../lib/money";
import type { Product } from "../types/catalog";
import "./ProductCard.css";

type ProductCardProps = {
  isAdmin: boolean;
  product: Product;
  onAddToCart: (product: Product) => void;
  onOpenProduct: (product: Product) => void;
  onTogglePromoted: (product: Product) => void;
};

export function ProductCard({
  isAdmin,
  product,
  onAddToCart,
  onOpenProduct,
  onTogglePromoted,
}: ProductCardProps) {
  const stockLabel = isAdmin
    ? `${product.stockQty} in stock`
    : product.stockQty <= 0
      ? "Out of stock"
      : product.stockQty <= 3
        ? "Few units left"
        : "";

  return (
    <article className="product-card">
      <button className="product-card__summary" type="button" onClick={() => onOpenProduct(product)}>
        <CatalogImage
          className="product-card__image"
          alt={product.imageAlt}
          preset="productCard"
          storageKey={product.imageStorageKey}
        />
          <div className="product-card__body">
          <div>
            <p className="eyebrow">{product.category}</p>
            <h3>{product.name}</h3>
            <p className="product-card__fitment">{formatFitmentLabel(product)}</p>
          </div>
          <div className="product-card__chips">
            <span>{product.condition}</span>
            {product.fitmentMake ? <span>{product.fitmentMake}</span> : null}
            {product.fitmentModel ? <span>{product.fitmentModel}</span> : null}
          </div>
          <div className="product-card__meta">
            <span>{product.brand}</span>
            <span>{product.sku}</span>
          </div>
          <div className="product-card__footer">
            <strong>{moneyFormatter.format(product.priceKes)}</strong>
            {stockLabel ? <span>{stockLabel}</span> : null}
          </div>
        </div>
      </button>
      <div className="product-card__actions">
        <button className="button" type="button" onClick={() => onAddToCart(product)}>
          Add to cart
        </button>
        {isAdmin ? (
          <button
            className="button button--ghost"
            type="button"
            onClick={() => onTogglePromoted(product)}
          >
            {product.isPromoted ? "Unpromote" : "Promote"}
          </button>
        ) : null}
      </div>
    </article>
  );
}
